import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";

export enum FrontendFieldType {
    text,
    textArea,
    maskField,
    password,
    comboBox,
    comboBoxCascade,
    comboBoxMulti,
    listBox,
    checkBox,
    radioButton,
    datePicker,
    button,
    buttonAsLink,
    table,
    groupBox,
    color,
    int,
    decimal,
    rating,
    stringList,
    fileSelect,
    fileUpload,
    imageUpload,
    pageControl,
    page,
    custom
}

export namespace FrontendFieldType{
    export function fromGenericDataType(value: GenericDataType): FrontendFieldType {
        switch (value) {
            case GenericDataType.string:
                return FrontendFieldType.text;
            case GenericDataType.int:
                return FrontendFieldType.int;
            case GenericDataType.decimal:
                return FrontendFieldType.decimal;
            case GenericDataType.bool:
                return FrontendFieldType.checkBox;
            case GenericDataType.date:
                return FrontendFieldType.datePicker;
            case GenericDataType.dateTime:
                return FrontendFieldType.datePicker;
            case GenericDataType.array:
                return FrontendFieldType.text;
            case GenericDataType.object:
                return FrontendFieldType.text;
        }
    }

    export function getDefaultValue(value: FrontendFieldType): any {
        switch (value) {
            case FrontendFieldType.text:
            case FrontendFieldType.textArea:
            case FrontendFieldType.password:
            case FrontendFieldType.maskField:
            case FrontendFieldType.comboBox:
            case FrontendFieldType.comboBoxCascade:
            case FrontendFieldType.comboBoxMulti:
                return "";
            case FrontendFieldType.checkBox:
                return false;
            case FrontendFieldType.table:
                return [];
            default:
                return null;
        }
    }

    export function hasLabel(value: FrontendFieldType): boolean {
        return value != FrontendFieldType.checkBox && value != FrontendFieldType.radioButton && value != FrontendFieldType.button && value != FrontendFieldType.buttonAsLink;
    }
}
